import { Component } from '@angular/core';
import { EkButtonComponent } from '@beta-foundations/ui-kit/buttons';
import { EkDialogBodyComponent, EkDialogFooterComponent } from '@beta-foundations/ui-kit/overlay/dialog';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslateModule } from '@ngx-translate/core';
import { LogoutMessageComponent } from './logout-message/logout-message.component';

@Component({
  selector: 'app-logout-page',
  standalone: true,
  imports: [EkDialogBodyComponent,
    EkDialogFooterComponent,
    EkButtonComponent,
    TranslateModule],
  templateUrl: './logout-page.component.html',
  styleUrl: './logout-page.component.scss',
})

export class LogoutPageComponent {
  userName: string | null = null;

  constructor(
    private dialogService: DialogService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig) {
    this.userName = this.config.data?.userName ?? null
  }

  logout() {
    throw new Error('Method not implemented.');
  }

  onConfirm(): void {
    const confirmRef = this.dialogService.open(LogoutMessageComponent, {
      width: '450px',
      height: '200px',
      modal: true,
      dismissableMask: true,
      style: { right: '7vh', top: '8vh', position: 'fixed', overflow: 'auto' },
      contentStyle: { overflow: 'auto' },
    });

    confirmRef.onClose.subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.ref.close(true);
      }
    });
  }

  onCancel(): void {
    this.ref.close(false);
  }
}
